<style>

.tableDesign .el-input__inner{
  border: 0;
  text-align: center;
}
</style>
<template>
  <BasicLayout>
    <template #wrapper>
      <el-tabs active-name="1" tab-position="left" style="background-color: #ffffff;height: 800px" @tab-click="handleTabClick">
        <el-tab-pane name="1" label="基础配置">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <el-row :gutter="10">
                <CommonExcel ref="CommonExcelRef" :import-p="'config:userLabel:import'" :export-p="'config:userLabel:export'" :import-method="importBaseCfg" :export-method="exportBaseCfg" />
                <clear-cache-apply />
                <sync-data />
              </el-row>
            </div>

            <el-table size="mini" :data="baseList" border style="width: 100%;min-height: 100px;" highlight-current-row>
              <el-table-column align="center" label="序号" width="50">
                <template v-slot:default="{row, $index}">
                  <span style="display:block">{{ $index+1 }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="最小等级" width="150">
                <template v-slot:default="{row}">
                  <el-input v-model="row.minLv" placeholder="最小等级" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="最大等级" width="150">
                <template v-slot:default="{row}">
                  <el-input v-model="row.maxLv" placeholder="最大等级" />
                </template>
              </el-table-column>
              <el-table-column label="用户分组" min-width="100%" align="center">
                <template v-slot:default="scope">
                  <el-select v-model="scope.row.groupIds" multiple>
                    <el-option v-for="item in groupsList" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="复活配置" align="center">
                <template v-slot:default="scope">
                  <el-select v-model="scope.row.revive">
                    <el-option v-for="item in list[3]" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="间距配置" align="center">
                <template v-slot:default="scope">
                  <el-select v-model="scope.row.distance">
                    <el-option v-for="item in list[4]" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="倍率系数配置" align="center">
                <template v-slot:default="scope">
                  <el-select v-model="scope.row.bet">
                    <el-option v-for="item in list[6]" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="地图配置" align="center">
                <template v-slot:default="scope">
                  <div style="width: 100%;height: 100%;min-height: 1rem;white-space: pre-wrap" @click="handleEditMapWeight(scope.row.mapWeight)">
                    <i class="el-icon-edit-outline" style="margin-right: 0.5rem" /><pre>{{ handleMapWeight(scope.row.mapWeight) }}</pre>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="100">
                <template v-slot:default="{row,$index}">
                  <el-button size="mini" type="danger" @click="deleteBaseConfig($index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="float:left;margin-top: 1rem">
              <el-button type="primary" size="mini" @click="addBaseConfig()">新增</el-button>
              <el-button v-prevent-re-click type="primary" size="mini" style="margin:10px 10px" @click="handleSaveBase()">保存</el-button>
            </div>
          </el-card>
        </el-tab-pane>
        <el-tab-pane v-for="(item,type) in typeArr" :key="type" :name="type" :label="item">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <el-row :gutter="10" class="mb8">
                <CommonExcel ref="CommonExcelRef2" :import-p="'config:userLabel:import'" :export-p="'config:userLabel:export'" :import-method="importCfg" :export-method="exportCfg" />
              </el-row>
            </div>
            <el-table class="tableDesign" size="mini" :data="list[type]" border style="width: 50%">
              <el-table-column label="序号" align="center" width="100">
                <template v-slot:default="{row,$index}">
                  <span style="display:block;" :title="row.id">{{ $index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="名称" align="center">
                <template v-slot:default="{row}">
                  <el-input v-model="row.name" style="width: 250px;" placeholder="名称" />
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template v-slot:default="{row,$index}">
                  <el-button type="primary" size="mini" @click="openDialog(row.config)">查看</el-button>
                  <el-button type="danger" size="mini" @click="handleDel($index,row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="float:left;margin-top: 1rem">
              <el-button type="primary" size="mini" @click="handleAdd(type,'新增配置',[])">新增</el-button>
              <el-button v-prevent-re-click type="primary" size="mini" style="margin:10px 10px" @click="handleSaveConfig(type)">保存</el-button>
            </div>
          </el-card>
        </el-tab-pane>
      </el-tabs>
      <el-dialog title="提示" :visible.sync="dialog" width="60%">
        <el-table size="mini" :data="diaLogList" border fit highlight-current-row style="width: 100%;" height="500">
          <template v-if="type === 2">
            <el-table-column label="序号" align="center" width="50">
              <template v-slot:default="{row,$index}"><span> {{ $index + 1 }}</span></template>
            </el-table-column>
            <el-table-column label="阶段" align="center" width="200">
              <template v-slot:default="{row}">
                <el-input v-model="row.stage" placeholder="阶段" />
              </template>
            </el-table-column>
            <el-table-column label="转弯(0/1)" align="center" width="200">
              <template v-slot:default="{row}">
                <el-input v-model="row.swerve" placeholder="转弯" />
              </template>
            </el-table-column>
            <el-table-column label="中心点额外倍数" align="center" width="200">
              <template v-slot:default="{row}">
                <el-input v-model="row.bet" placeholder="中心点额外倍数" />
              </template>
            </el-table-column>
            <el-table-column label="奖励" align="center">
              <template v-slot:default="scope">
                <Reward v-model="scope.row.reward" :limit-len="1" />
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template v-slot:default="{row,$index}">
                <el-button style="margin-left: .5rem;display:block;" size="mini" type="danger" @click="deleteRewardDialogList($index)">删除</el-button>
              </template>
            </el-table-column>
          </template>
          <template v-if="type === 3">
            <el-table-column label="序号" align="center" width="50">
              <template v-slot:default="{row,$index}"><span> {{ $index + 1 }}</span></template>
            </el-table-column>
            <el-table-column label="价格" align="center">
              <Price />
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template v-slot:default="{row,$index}">
                <el-button style="margin-left: .5rem;display:block;" size="mini" type="danger" @click="deleteRewardDialogList($index)">删除</el-button>
              </template>
            </el-table-column>
          </template>
          <template v-if="type === 4">
            <el-table-column label="序号" align="center" width="50">
              <template v-slot:default="{row,$index}"><span> {{ $index + 1 }}</span></template>
            </el-table-column>
            <el-table-column label="格子范围(min)" align="center" width="200">
              <template v-slot:default="{row}">
                <el-input-number v-model="row.gridMin" :controls="false" placeholder="间距(min)" />
              </template>
            </el-table-column>
            <el-table-column label="格子范围(max)" align="center" width="200">
              <template v-slot:default="{row}">
                <el-input-number v-model="row.gridMax" :controls="false" placeholder="间距(max)" />
              </template>
            </el-table-column>
            <el-table-column label="权重" align="center" width="200">
              <template v-slot:default="{row}">
                <el-input-number v-model="row.weight" :controls="false" placeholder="阶段" />
              </template>
            </el-table-column>
            <el-table-column label="间距范围(min)" align="center" width="200">
              <template v-slot:default="{row}">
                <el-input-number v-model="row.distanceMin" :controls="false" placeholder="间距(min)" />
              </template>
            </el-table-column>
            <el-table-column label="间距范围(max)" align="center" width="200">
              <template v-slot:default="{row}">
                <el-input-number v-model="row.distanceMax" :controls="false" placeholder="间距(max)" />
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template v-slot:default="{row,$index}">
                <el-button style="margin-left: .5rem;display:block;" size="mini" type="danger" @click="deleteRewardDialogList($index)">删除</el-button>
              </template>
            </el-table-column>
          </template>
          <template v-if="type === 5">
            <el-table-column label="序号" align="center" width="50">
              <template v-slot:default="{row,$index}"><span> {{ $index + 1 }}</span></template>
            </el-table-column>
            <el-table-column label="背景" align="center">
              <template v-slot:default="{row}">
                <el-input v-model="row.background" placeholder="背景" />
              </template>
            </el-table-column>
            <el-table-column label="权重" align="center">
              <template v-slot:default="{row}">
                <el-input v-model="row.v" placeholder="权重" />
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template v-slot:default="{row,$index}">
                <el-button style="margin-left: .5rem;display:block;" size="mini" type="danger" @click="deleteRewardDialogList($index)">删除</el-button>
              </template>
            </el-table-column>
          </template>
          <template v-if="type === 6">
            <el-table-column label="序号" align="center" width="50">
              <template v-slot:default="{row,$index}"><span> {{ $index + 1 }}</span></template>
            </el-table-column>
            <el-table-column label="倍率" align="center">
              <template v-slot:default="{row}">
                <el-input v-model="row.bet" placeholder="倍率" />
              </template>
            </el-table-column>
            <el-table-column label="系数" align="center">
              <template v-slot:default="{row}">
                <el-input v-model="row.coef" placeholder="系数" />
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template v-slot:default="{row,$index}">
                <el-button style="margin-left: .5rem;display:block;" size="mini" type="danger" @click="deleteRewardDialogList($index)">删除</el-button>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <span v-if="type === 2 || type === 3 || type === 4 || type === 5 || type === 6" slot="footer" class="dialog-footer" style="margin-right: 10px"><el-button type="primary" @click="addRewardDialogList">新增</el-button></span>
        <span slot="footer" class="dialog-footer"><el-button @click="dialog = false">关 闭</el-button></span>
      </el-dialog>
      <el-dialog title="地图权重" :visible.sync="mapDialog" width="40%">
        <el-table size="mini" :data="mapDialogList" border fit highlight-current-row style="width: 100%;" height="500">
          <el-table-column label="权重" align="center">
            <template v-slot:default="{row}">
              <el-input v-model="row.v" style="width: 250px;" placeholder="权重" />
            </template>
          </el-table-column>
          <el-table-column label="速度" align="center" width="150">
            <template v-slot:default="{row}">
              <el-input v-model="row.speed" placeholder="速度" />
            </template>
          </el-table-column>
          <el-table-column label="地图" align="center">
            <template v-slot:default="scope">
              <el-select v-model="scope.row.id">
                <el-option v-for="item in list[2]" :key="item.id" :value="item.id" :label="item.name" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="背景" align="center">
            <template v-slot:default="scope">
              <el-select v-model="scope.row.background">
                <el-option v-for="item in list[5]" :key="item.id" :value="item.id" :label="item.name" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="100">
            <template v-slot:default="{row,$index}">
              <el-button style="margin-left: .5rem;display:block" type="danger" size="mini" @click="deleteMapDialogList($index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer" style="margin-right: 10px"><el-button type="primary" @click="addMapDialogList">新增</el-button></span>
        <span slot="footer" class="dialog-footer"><el-button @click="mapDialog = false">关 闭</el-button></span>
      </el-dialog>
    </template>
  </BasicLayout>
</template>

<script>

import CommonExcel from '@/components/CommonExcel'
import Reward from '@/components/Reward'
import { downloadExcelMultiSheet } from '@/utils/excel'
import { getUserTypeAllList } from '@/api/config/user-group-cfg'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import Price from '@/components/Price'
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'
import {
  actionComAuxiliary,
  comAuxiliary, delActAuxiliary
} from '@/api/config/activity-auxiliary-cfg'
import SyncData from '@/components/syncData/index.vue'

export default {
  name: 'BridgeGame',
  components: { SyncData, Price, ClearCacheApply, CommonExcel, Reward },
  data() {
    return {
      curClass: 'bridgeGame',
      loading: false,
      dialog: false,
      diaLogList: [],
      list: [],
      type: 1,
      typeArr: { 2: '地图配置', 3: '商品配置', 4: '间距配置', 5: '背景配置', 6: '倍率系数配置' },
      baseList: [],
      mapDialog: false,
      mapDialogList: [],
      groupsList: []
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getList()
      this.initBase()
    },
    initBase() {
      getUserTypeAllList().then(res => {
        res.data.forEach(res => {
          this.groupsList.push({ name: res.name, id: res.groupId })
        })
        getCommonCfg({ name: this.curClass }).then(res => {
          if (res.data) {
            this.baseList = res.data
          }
        })
      })
    },
    openDialog(config) {
      this.dialog = true
      this.diaLogList = config
    },
    handleTabClick(val) {
      this.type = Number(val.name)
      console.log(this.type)
      this.diaLogList = []
    },
    handleSaveBase() {
      updateCommonCfg({ name: this.curClass, data: JSON.stringify(this.baseList) }).then(res => {
        this.msgSuccess('保存成功')
      })
    },
    importBaseCfg(excelInfo) {
      const excelData = excelInfo.data
      for (let i = 0; i < excelData.length; i++) {
        const list = this.$refs.CommonExcelRef.tranToTarget(excelData[i].sheetData, { groupIds: this.groupsList, revive: this.list[3] }, true, 'name', 'id')
        for (let i = 0; i < list.length; i++) {
          list[i].mapWeight = this.$refs.CommonExcelRef.tranToTarget(list[i].mapWeight, { id: this.list[2] }, true, 'name', 'id')
        }
        this.baseList = list
        this.handleSaveBase()
        break
      }
    },
    exportBaseCfg() {
      const fileName = '搭桥快跑配置'
      const hearer = []
      const excelData = []
      const name = ['搭桥快跑配置']
      const list = this.$refs.CommonExcelRef.tranToTarget(this.baseList, { groupIds: this.groupsList, revive: this.list[3] }, true, 'id', 'name')
      for (let i = 0; i < list.length; i++) {
        list[i].mapWeight = this.$refs.CommonExcelRef.tranToTarget(list[i].mapWeight, { id: this.list[2] }, true, 'id', 'name')
      }
      const tAk = this.$refs.CommonExcelRef.makeExcelData(list, { minLv: '最小等级', maxLv: '最大等级', groupIds: { name: '用户分组', sub: [] }, revive: '复活配置', mapWeight: { name: '地图配置', sub: { v: '权重', id: '地图', background: '背景' }}})
      hearer.push(tAk[0])
      excelData.push(tAk[1])
      downloadExcelMultiSheet(this.$route.meta.title + fileName, name, hearer, excelData)
    },
    getList() {
      this.loading = true
      comAuxiliary({ class: this.curClass, select: 0 }).then(response => {
        this.list = response.data
        for (const key in this.typeArr) {
          if (this.list[key] === undefined || this.list[key] == null) {
            this.list[key] = []
          }
        }
        this.loading = false
      })
    },
    handleDel(index, id) {
      if (id !== 0) {
        delActAuxiliary({ idList: [id] })
      }
      this.list[this.type].splice(index, 1)
    },
    handleAdd(type, name, config) {
      this.list[type].push({ id: 0, name: name, class: this.curClass, type: this.type, config: config })
    },
    importCfg(updateInfo) {
      const excelData = updateInfo.data
      for (let i = 0; i < excelData.length; i++) {
        const sheet = excelData[i].sheetName
        let editFlag = false
        for (let j = 0; j < this.list[this.type].length; j++) {
          if (this.list[this.type][j].name === sheet) {
            this.list[this.type][j].config = excelData[i].sheetData
            editFlag = true
          }
        }
        if (!editFlag) {
          this.handleAdd(this.type, sheet, excelData[i].sheetData)
        }
      }
    },
    handleSaveConfig(type) {
      actionComAuxiliary({ class: this.curClass, list: this.list }).then(response => {
        this.msgSuccess('保存成功', () => { this.getList() }, 1000)
      })
    },
    exportCfg() {
      const nameArr = []
      const dataArr = []
      for (let i = 0; i < this.list[this.type].length; i++) {
        nameArr.push(this.list[this.type][i].name)
        dataArr.push(this.list[this.type][i].config)
      }
      this.onExport(this.type, nameArr, dataArr)
      return Promise.reject()
    },
    onExport(type, name, dataArr) {
      const fileName = ''
      const hearer = []
      const excelData = []
      downloadExcelMultiSheet(this.$route.meta.title + fileName, name, hearer, excelData)
    },
    addBaseConfig() {
      this.baseList.push({ groupIds: [], mapWeight: [], revive: 0, bet: 0 })
    },
    deleteBaseConfig(index) {
      this.baseList.splice(index, 1)
    },
    addMapDialogList() {
      this.mapDialogList.push({ v: 1, speed: 1, id: 0 })
    },
    deleteMapDialogList(index) {
      this.mapDialogList.splice(index, 1)
    },
    handleEditMapWeight(config) {
      this.mapDialog = true
      this.mapDialogList = config
    },
    handleGetMapName(id) {
      for (let i = 0; i < this.list[2].length; i++) {
        if (this.list[2][i].id === id) {
          return this.list[2][i].name
        }
      }
      return ''
    },
    handleMapWeight(data) {
      let str = ''
      for (let i = 0; i < data.length; i++) {
        str += '权重：' + data[i].v + '，地图：' + this.handleGetMapName(data[i].id) + '\n'
      }
      return str
    },
    handleDownLoadJson() {
      window.open(process.env.VUE_APP_BASE_API + '/api/v1/export/makeParkourJson')
    },
    addRewardDialogList() {
      if (this.type === 2) {
        this.diaLogList.push({ stage: 1, swerve: 0, bet: 0, reward: [] })
      } else if (this.type === 3) {
        this.diaLogList.push({ mtype: 1, bet: 1, sku: '', price: 0, coin: 'money1' })
      } else if (this.type === 4) {
        this.diaLogList.push({ gridMin: 1, gridMax: 1, weight: 1, distanceMin: 1, distanceMax: 1 })
      } else if (this.type === 5) {
        this.diaLogList.push({ background: 1, v: 1 })
      } else if (this.type === 6) {
        this.diaLogList.push({ bet: 1, coef: 1 })
      }
    },
    deleteRewardDialogList(index) {
      this.diaLogList.splice(index, 1)
    }
  }
}
</script>

